import axios from 'axios';
import Vue from 'vue';

export default async function (signedUrl, file) {
  const token = Vue.prototype.$auth.idTokenClaims.__raw;
  const fileArrayBuffer = await parse(file);
  return axios({
    method: 'PUT',
    url: signedUrl,
    data: fileArrayBuffer,
    headers: {
      'Content-Type': file.type,
      Authorization: `Bearer ${token}`
    }
  });
}

export function parse(file) {
  return new Promise((resolve, reject) => {
    let content = '';
    const reader = new FileReader();
    reader.onloadend = function (e) {
      content = e.target.result;
      resolve(content);
    };
    reader.onerror = function (e) {
      reject(e);
    };
    reader.readAsArrayBuffer(file);
  });
}
